import { pdfAnswerType } from '../steps/pdf/template.js';
export const offerSigningFields = [
    { id: 'acceptance', kind: 'checkbox', label: 'Accept these terms' },
    { id: 'signature', kind: 'typed-signature', label: 'Typed full name' },
    { id: 'signedDate', kind: 'date', label: 'Signing date' },
];
/**
 * How much of the signing page the candidate actually filled in.
 *
 * NOT `isPdfFieldAnswered`, and the difference is the whole point of this function. That one
 * treats a false checkbox as answered — correctly, because for an ordinary questionnaire saying
 * no IS answering, and requiring a tick would turn every required checkbox into a compulsory
 * agreement. On an OFFER the acceptance box is the agreement: an unticked box is a candidate who
 * did not accept, which `checkPdfAcceptance` refuses at submit. Counting it as completed would put
 * "All 3 signing fields completed" beside an offer nobody agreed to.
 *
 * Takes the values map rather than the step so a caller can ask about a submission it is holding
 * for another reason, and so this is trivially testable without building an instance.
 */
export function offerSigningCompletion(values) {
    const missing = offerSigningFields.filter((field) => {
        const value = values[field.id];
        if (pdfAnswerType(field.kind) === 'boolean')
            return value !== true;
        return typeof value !== 'string' || value.trim() === '';
    });
    return {
        total: offerSigningFields.length,
        completed: offerSigningFields.length - missing.length,
        missing: missing.map((field) => field.label),
    };
}
export function signedOfferStage(step) {
    if (step.state === 'submitted')
        return 'awaiting-hr';
    if (step.state === 'approved')
        return 'filed';
    return null;
}
/**
 * Did the signature land before the offer's Accept-by date?
 *
 * Compared as INSTANTS, not calendar days, because `acceptanceDeadline` carries a time of day the
 * frame prints in full ("Sep 21, 2026, 5:00 PM"). `daysUntilDeadline` in offers.ts deliberately
 * counts whole days instead, for a list that says "3 days left"; this is the different question of
 * whether one moment preceded another, and rounding it to days would call a signature that arrived
 * at 9pm on the deadline day on time.
 *
 * `null` when either moment is absent — an offer with no deadline cannot be late, and an unsigned
 * step has nothing to judge, so neither is a failed check.
 */
export function signedBeforeDeadline(submittedAt, deadline) {
    if (submittedAt === null || deadline === null)
        return null;
    return Date.parse(submittedAt) <= Date.parse(deadline);
}
//# sourceMappingURL=offer-signing.js.map